<div class="flex flex-row">
    <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>

<div class="flex flex-row justify-between items-center pl-24 pr-24 pb-8 pt-32">
  <div class="mat-headline-5 m-0">{{'TENANT_DASHBOARD.TENANTS' | transloco }}</div>
  <div class="flex flex-row justify-center items-center">
    <div>
      <div *ngIf="permissionsMap[PermissionKeys.TENANT_CREATE]" class="right-tenant fs-16 fw-700 pr-6">
        <button  type="button" class="flex justify-center items-center tenant-gradient download-btn layout-row layout-align-end-start mat-body-2 mb-10 fw-700" mat-button (click)="downloadWithResetIds()">
          <mat-icon svgIcon="file_download" class="icon-md-2 pr-4"></mat-icon>
          {{'TENANT_FORM.DONWLOAD_TEMPLATE' | transloco }}
        </button>
      </div>
      <div *ngIf="permissionsMap[PermissionKeys.TENANT_CREATE]" class="right-tenant fs-16 fw-700 pr-6">
        <button  type="button" class="flex justify-center items-center tenant-gradient layout-row layout-align-end-start mat-body-2 mb-10 fw-700" mat-button (click)="createTenant()">
          <mat-icon svgIcon="add" class="icon-md-2 pr-4"></mat-icon>
          {{'TENANT_FORM.NAME' | transloco }}
        </button>
      </div>
      <button *ngIf="permissionsMap[PermissionKeys.TENANT_CREATE] || permissionsMap[PermissionKeys.TENANT_READ]" class="flex justify-center items-center context-menu-icon" (click)="filterColumns()">
        <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
        <span class="mat-body-1 fw-500">{{'TENANT_LIST.FILTERS' | transloco}}</span>
      </button>
    </div>
  </div>
</div>

<div class="flex flex-row flex-wrap justify-start items-center pt-10 pl-24 pr-24 pb-10">
  <ng-container *ngIf="type">
    <div class="flex flex-row items-center">
      <span class="fw-400">{{ 'TOOLBAR.TYPE' | transloco }} </span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{type === ManagementTypes.EXTERNAL? ('INSTANCE_LIST.EXTERNAL' | transloco) : ('INSTANCE_LIST.EXTERNAL_FOR_ACTION' | transloco)}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(type)"></mat-icon>
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="region">
    <div class="flex flex-row items-center">
      <span class="fw-400">{{ 'TOOLBAR.REGION' | transloco }} </span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{region}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(region)"></mat-icon>
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="cloud">
    <div class="flex flex-row items-center mr-16">
      <span class="fw-400">{{ 'TOOLBAR.CLOUD' | transloco }}</span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{cloud | titlecase}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(cloud)"></mat-icon>
      </span>
    </div>
  </ng-container>
  <ng-container *ngIf="status">
    <div class="flex flex-row items-center mr-16">
      <span class="fw-400">{{ 'TOOLBAR.STATUS' | transloco }}</span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{status | titlecase}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(status)"></mat-icon>
      </span>
    </div>
  </ng-container>
  <div class="flex flex-row items-center mr-16">
    <span *ngIf="region || cloud || status" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"
      (click)="resetFilter()">
      {{ 'BUTTONS.CLEAR_ALL' | transloco }}
    </span>
  </div>
</div>
<ng-container *ngIf="permissionsMap[PermissionKeys.TENANT_READ] else unauthorized">
  <div class="top-panel p-16">
    <div class="flex flex-col border-radius">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mat-elevation">
      <ng-container matColumnDef="tenantId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_LIST.TENANTID' | transloco }}</th>
        <td mat-cell *matCellDef="let data" class="cursor-pointer flex flex-row pt-10 img-column" (click)="tenantDetails(data)">
          <img class ="icon-lg mr-8" src="assets/images/bank.png" alt="bank">
          <span class="tenant-id pt-2">{{data.tenantId}}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_LIST.REGION' | transloco }} </th>
        <td mat-cell *matCellDef="let data"> {{data.regionPair || data.temenosRegion ? data.regionPair || data.temenosRegion :"--"}} </td>
      </ng-container>

      <!-- <ng-container matColumnDef="primaryRegion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_LIST.PRIMARY_REGION' | transloco }} </th>
        <td mat-cell *matCellDef="let data"> {{(data.primaryCloudRegion || data.primaryRegion) ? ((data.primaryCloudRegion | titlecase) || (data.primaryRegion | titlecase)) : '--'}} </td>
      </ng-container>

      <ng-container matColumnDef="secondaryRegion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_LIST.SECONDARY_REGION' | transloco }} </th>
        <td mat-cell *matCellDef="let data"> {{(data.secondaryCloudRegion || data.secondaryRegion) ? ((data.secondaryCloudRegion | titlecase) || (data.secondaryRegion | titlecase)) : '--'}} </td>
      </ng-container> -->

      <ng-container matColumnDef="target">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_LIST.CLOUD' | transloco }} </th>
        <td mat-cell *matCellDef="let data"> {{(data.cloudProvider || data.targetCloud) | titlecase}} </td>
      </ng-container>

      <ng-container matColumnDef="dateCreated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_LIST.DATE_CREATED' | transloco }} </th>
        <td mat-cell *matCellDef="let data"> {{dateTimeFormatService.getUtcFromat(data.dateCreated)}} </td>
      </ng-container>
      <ng-container matColumnDef="creationFlow">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TENANT_LIST.CREATION_FLOW' | transloco }} </th>
        <td mat-cell *matCellDef="let data">
          <a class="cursor-pointer" (click)="openWorkflowDiagram(data)">{{ 'TENANT_LIST.VIEW_CREATION_FLOW' | transloco }}</a>
        </td>
      </ng-container>
      <ng-container matColumnDef="menu">
        <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
        <td mat-cell *matCellDef="let data">
          @if(permissionsMap[PermissionKeys.TENANT_UPDATE]){
          <button class="flex justify-center items-center context-menu-icon pl-6 pr-6 pt-8"
            [matMenuTriggerFor]="instanceSubmenu">
            <mat-icon svgIcon="more_vert"></mat-icon>
          </button>
          <mat-menu #instanceSubmenu [xPosition]="'before'" class="context-menu-dropdown">
            <div class="flex flex-col">
              <button class="menu-button" (click)="editTenant(data)">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="edit" class="icon-md"></mat-icon>
                  <div class="mat-body fw-400">{{'TENANT_LIST.EDIT_TENANT_DETAILS' | transloco }}</div>
                </div>
              </button>
            </div>
          </mat-menu>
         }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-card *ngIf="showSpinner" class="flex spinner-container spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </mat-card>
    <div *ngIf="data?.length === 0 && !showSpinner && !isFailed" class="flex justify-center p-10 pt-30 pb-30">
      {{'TENANT_LIST.NO_TENANT_MESSAGE' | transloco }}
    </div>
    <div *ngIf="isFailed" class="flex items-center justify-center pt-48 pb-48">
      {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
    </div>
    <app-paginator *ngIf="showPagination && !showSpinner && !isFailed" class="p-24" [length]="data?.length" [pageSizeOptions]="[10, 15, 20]"
        [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)"></app-paginator>
    </div>
  </div>
</ng-container>
<ng-template #unauthorized>
  <div class="pt-38 unauth-container pb-50 mb--20">
    <img class="image" src="/assets/images/unauthorized.svg">
    <div class="fw-600 fs-20 mat-subtitle-2 mt-32"> {{ 'UNAUTHORIZED.MESSAGE' | transloco }}</div>
  </div>
</ng-template>
